module.exports = __webpack_public_path__ + "media/images/exclamation_mark-122d6835e1925512829ea6a051215012.svg";